<div class="relative">
  <button (click)="onClick.emit()"
    [title]="title"
    [style.width]="width"
    [style.height]="height"
    [disabled]="disabled"
    [class.deactivated]="disabled || isLoading"
    [attr.type]="fileButton ? 'file' : undefined"
    class="buttontype-{{buttonType}} flex flex-row gap-2 items-center justify-center">
    @if (icon !== null && !isLoading) {
      <fa-icon style="font-size: 16px;" [icon]="icon" />
    }
    <span>{{ text }}</span>
  </button>
  @if (isLoading) {
    <fa-icon class="absolute left-4 top-1/2 transform -translate-y-1/2 text-2xl" [icon]="'loader'" animation="spin" />
  }
</div>
